import React from "react";

import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

const fields = ({ t }) => [
  ...contactFields({ t, includeAccountNumber: false}),
  {
    key: "message",
    label: t("forms.contact.message"),
    type: "textarea",
    required: true,
    inputProps: {
      minRows: 4,
    },
  },
];

const HereToHelpForm = ({ moduleKey }) => (
  <DynamicForm
    formKey={moduleKey}
    fields={fields}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default HereToHelpForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/HereToHelpForm.js